import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

type PetTagResponse = {
  id: number;
  nome: string;
  tipo_pet: string;
  raca: string | null;
  foto: string | null;
  observacoes: string | null;
  tutor: {
    nome: string | null;
    telefone: string | null;
  };
};

export default function PetTagPublica() {
  const { token } = useParams();
  const [pet, setPet] = useState<PetTagResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    async function carregar() {
      try {
        setLoading(true);
        setErro("");

        const resp = await fetch(`/api/pet/tag/${token}`, {
          headers: { Accept: "application/json" },
        });

        if (!resp.ok) {
          throw new Error("Pet não encontrado");
        }

        const data = await resp.json();
        setPet(data);
      } catch (e) {
        setErro("Não foi possível carregar a identificação do pet.");
      } finally {
        setLoading(false);
      }
    }

    if (token) {
      carregar();
    }
  }, [token]);

  if (loading) {
    return <div style={{ padding: 24 }}>Carregando...</div>;
  }

  if (erro || !pet) {
    return <div style={{ padding: 24 }}>{erro || "Pet não encontrado."}</div>;
  }

  return (
    <div style={{ background: "#f5f5f5", minHeight: "100vh", padding: 16 }}>
      <div
        style={{
          maxWidth: 520,
          margin: "0 auto",
          background: "#fff",
          borderRadius: 16,
          padding: 24,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <img
          src={pet.foto || "/images/placeholders/pet-default.png"}
          alt={pet.nome}
          style={{
            width: 180,
            height: 180,
            objectFit: "cover",
            borderRadius: 12,
            marginBottom: 16,
            background: "#eee",
          }}
        />

        <h1 style={{ marginBottom: 12 }}>{pet.nome}</h1>

        <p><strong>Tipo:</strong> {pet.tipo_pet}</p>

        {pet.raca && (
          <p><strong>Raça:</strong> {pet.raca}</p>
        )}

        {pet.observacoes && (
          <p><strong>Observações:</strong> {pet.observacoes}</p>
        )}

        <div
          style={{
            marginTop: 20,
            padding: 12,
            borderRadius: 10,
            background: "#fff8e1",
          }}
        >
          <strong>Encontrou este pet?</strong>
          <div>Entre em contato com o tutor.</div>
        </div>

        {pet.tutor?.nome && (
          <p style={{ marginTop: 20 }}>
            <strong>Tutor:</strong> {pet.tutor.nome}
          </p>
        )}

        {pet.tutor?.telefone && (
          <p>
            <strong>Telefone:</strong> {pet.tutor.telefone}
          </p>
        )}
      </div>
    </div>
  );
}